"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._checksumIgnore = void 0;
exports._checksumIgnore = {
    user: [
        '_id',
        'checksum',
        'date_create',
        'date_update',
        'date_update_unix',
        'date_active',
        'date_welcome_email',
        '_email',
    ],
    location: [
        '_id',
        'checksum',
        'date_create',
        'date_update',
        'date_update_unix',
        'date_cancelled'
    ],
    spotted: [
        '_id',
        'checksum',
        'date_create',
        'date_update',
        'date_update_unix',
        'vote',
        'view_count',
        'comment_count',
        'group',
        'env_name',
    ],
    vehicle: [
        '_id',
        'checksum',
        'reference',
        'comment_count',
        'view_count',
        'vote',
        'date_create',
        'date_update',
        'date_update_unix',
        'group',
        'env_name',
    ],
    rawVehicle: [
        '_id',
        'checksum',
        'log',
        'date_create',
        'is_processed',
        'synced',
    ]
};
